var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.313,
    height: 292.001,
    viewBox: "0 0 212.313 292.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6170",
    "data-name": "Group 6170",
    transform: "translate(10125.314 15268.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8081",
    "data-name": "Path 8081",
    d: "M105.155,124.24a3.209,3.209,0,0,1-.1,5.567l-9.92,5.462a23.125,23.125,0,0,1-12.052,2.851c.037.04-13.543-.1-13.543-.1l3.523-16.251-45.337-27.4,9.593-10.631Z",
    transform: "translate(-10079.983 -15132.067)",
    fill: "#cad0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1451",
    "data-name": "Rectangle 1451",
    width: 78.991,
    height: 54.391,
    transform: "translate(-10052.255 -15048.323)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8082",
    "data-name": "Path 8082",
    d: "M123.839,128.76l-.124-.126c.477-1.818-.746-3.918-3.6-5.559l-17.4-10.017a9.563,9.563,0,0,1-4.793-8.289V96.416L65.615,77.648v5.781a4.783,4.783,0,0,1-7.169,4.145l-7.691-4.426c-4.434-2.553-11.074-3.022-14.829-1.051L15.665,92.706c-1.713.9-2.485,2.158-2.448,3.494-.04-.008-.04,4.824-.04,4.824.008,1.62,1.346,3.367,3.8,4.777l69.239,39.928c4.434,2.553,11.074,3.025,14.829,1.051l20.264-10.61c3.2-1.968,2.529-4.606,2.529-7.409",
    transform: "translate(-10103.771 -15142.032)",
    fill: "#e2e9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8083",
    "data-name": "Path 8083",
    d: "M65.387,110.321V82.394L33.08,66.665V95.6L65.387,114.37Z",
    transform: "translate(-10071.236 -15159.987)",
    fill: "#b8c9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8084",
    "data-name": "Path 8084",
    d: "M48.693,102.233V74.307L43.31,71.688v39.58a9.567,9.567,0,0,0,4.8,8.292l3.76,2.163a9.549,9.549,0,0,1-3.172-7.088v-12.4Z",
    transform: "translate(-10054.512 -15151.775)",
    fill: "#b8c9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8085",
    "data-name": "Path 8085",
    d: "M123.715,117.775a3.313,3.313,0,0,0-.2-1.981,5.01,5.01,0,0,1-2.211,2.471l-20.261,10.613c-3.755,1.971-10.394,1.5-14.829-1.054L16.977,87.9a7.621,7.621,0,0,1-3.573-3.67,3.151,3.151,0,0,0-.187,1.112c-.04-.008-.04,4.824-.04,4.824.005,1.618,1.346,3.365,3.8,4.777l69.239,39.925c4.434,2.553,11.074,3.025,14.829,1.054l20.261-10.613c3.207-1.966,2.532-4.606,2.532-7.406Z",
    transform: "translate(-10103.771 -15131.273)",
    fill: "#b8c9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8086",
    "data-name": "Path 8086",
    d: "M1.573,12.755l4.6,120.52a22.983,22.983,0,0,0,11.44,19.874L187.1,257.379c7.659,4.448,22.646-.324,22.646-12.6V122.649a22.984,22.984,0,0,0-11.475-19.893L23.421,1.628C13.366-3.362,1.573,3.9,1.573,12.755",
    transform: "translate(-10122.743 -15268.97)",
    fill: "#343c6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8087",
    "data-name": "Path 8087",
    d: "M1.276,46.2V60.41A22.986,22.986,0,0,0,12.714,80.285L187.582,181.85a11.49,11.49,0,0,0,17.26-9.936V164.44Z",
    transform: "translate(-10123.229 -15193.441)",
    fill: "#445393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M204.842,123.62a22.981,22.981,0,0,0-11.474-19.893L18.521,2.6A11.492,11.492,0,0,0,1.276,12.542V120.036L204.842,238.272Z",
    transform: "translate(-10123.229 -15267.276)",
    fill: "#e2e9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M6.108,5.837V107.543l178.1,103.447V108.85Z",
    transform: "translate(-10115.328 -15259.427)",
    fill: "#819bea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M92.848,59.889v50.675L37.078,78.172V27.632Z",
    transform: "translate(-10064.7 -15223.798)",
    fill: "#e2e9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M74.581,56.148v6.305L18.811,30.061V23.891Z",
    transform: "translate(-10094.563 -15229.913)",
    fill: "#e2e9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M83.268,76.291V82.57L42.94,59.141V52.989Z",
    transform: "translate(-10055.117 -15182.345)",
    fill: "#f8fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M74.581,60.574v50.675L18.811,78.857V28.316Z",
    transform: "translate(-10094.563 -15222.679)",
    fill: "#f8fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8094",
    "data-name": "Path 8094",
    d: "M34.753,50.6,31.31,53.8A6.473,6.473,0,0,1,29.7,54.836l-1.136.511a7.685,7.685,0,0,0-3.133,2.6l-2.255,3.286-4.542-3.952,3.844-4.318a46.621,46.621,0,0,1,2.637-4.379l4.458-6.835a.82.82,0,0,1,1.122-.3.909.909,0,0,1,.416.545,2.8,2.8,0,0,1,2.5-.588c2.313,1-2.026,8.307-2.327,8.829.2-.121,1.7-1.107,2.192-1.478a1.363,1.363,0,0,1,1.668.021,1.1,1.1,0,0,1-.39,1.81",
    transform: "translate(-10094.856 -15201.465)",
    fill: "#fcbac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M44.634,50.757l-10.75,15.2a21.571,21.571,0,0,1-1.494,1.76L17.991,82,7.576,74.452S13,70.9,13.86,70.141C18.252,66.31,23.393,61.8,24.307,61a18.988,18.988,0,0,0,1.8-1.8L38.435,46c2.453-.142,6.395,3.494,6.2,4.756",
    transform: "translate(-10112.93 -15193.773)",
    fill: "#b8c9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M47.427,43.471l-5.736,6.6a49.2,49.2,0,0,1-3.747,4.01l-2.577,4.553-7.87.177,4.432-6.323a8.3,8.3,0,0,0,1.776-4l.19-1.323a6.81,6.81,0,0,1,.593-1.96L38.128,41.5s.993-.877,1.37-.537a1.238,1.238,0,0,1,.429,1.5c-.258.661-1.771,1.765-1.771,1.765s6.653-7.193,8.434-5.022c.5.582.466,1.56.119,2.745a.914.914,0,0,1,.635.237.885.885,0,0,1,.082,1.288",
    transform: "translate(-10080.362 -15205.553)",
    fill: "#fcbac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M62.328,106.7a31.347,31.347,0,0,0-7-4.181,44.654,44.654,0,0,0-5.525-2.055c-.709-.211-1.418-.4-2.15-.59a59.623,59.623,0,0,0-11.88-1.794l-2.218-.071a64.078,64.078,0,0,0-8.6.424,51.327,51.327,0,0,0-10.418,2.316c-.593.187-1.159.4-1.726.614C5.516,104.2.769,108.517.089,112.935c-.667,4.274,2.572,7.865,5.38,10.133,6.524,5.243,17.271,8.479,28.774,8.716a55.348,55.348,0,0,0,20.738-3.378,30.548,30.548,0,0,0,7.512-4.11c2.948-2.245,4.814-4.843,5.217-7.464.664-4.276-2.574-7.865-5.383-10.133",
    transform: "translate(-10125.313 -15108.765)",
    fill: "#cad0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1452",
    "data-name": "Rectangle 1452",
    width: 67.799,
    height: 33.798,
    transform: "translate(-10125.314 -15010.768)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M20.974,101.8s-.04,2.1-2.648,3.942c-.372.263-.869.588-1.4.912a36.2,36.2,0,0,0-4.764,3.723,3.893,3.893,0,0,1-2.566,1.13c-1.576.05-2.951-.48-2.711-2.848.018-.161.04-.445.076-.73l.055-.382c.034-.174.213-4.566.232-4.661.177.8,1.338-2.284,2.021-2.3,1.035-.029.843,2.432,1.555,1.794,1.278-1.17,2.611-.6,6.089-2.295l.664-.095c2.68-.263,3.072.63,3.328,1.447a3.707,3.707,0,0,1,.071.366",
    transform: "translate(-10114.107 -15105.584)",
    fill: "#343c6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8099",
    "data-name": "Path 8099",
    d: "M30.719,105.635s-2.421-.279-3.23-.324c-1.908-.108-6.052-1.378-7.369-.5-1.5,1-4.806,1.794-4.8-.972l-1.894.572c-.045.588-.279,4-.292,4.221a4.859,4.859,0,0,0,.635,2.922c1.212,1.992,5.106.917,7.33.511l6.64-.764a5.746,5.746,0,0,0,4.484-3.562,1.886,1.886,0,0,0-1.5-2.1",
    transform: "translate(-10103.878 -15099.222)",
    fill: "#343c6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8100",
    "data-name": "Path 8100",
    d: "M8.175,70.826l-.833,2.856A12.841,12.841,0,0,0,6.9,75.84a60.547,60.547,0,0,0-.314,10.342l.416,7.543.559,61.965c-.216,2.487,8.089,2.893,8.118-.095l5.3-62.758,5.412,33.509-2.377,37.5c-.047,2.558,8.247,2.954,8.384-.126,0,0,6.727-33.918,6.848-40.328.105-5.644-2.24-38.6-2.537-43.735-.472-8.136-14.486-6.231-14.478-6.576l7.788-5.857Z",
    transform: "translate(-10114.689 -15159.081)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8101",
    "data-name": "Path 8101",
    d: "M14.78,78.167l-2.832-1.8a1.076,1.076,0,0,0-1.655.933l.44,46.035Z",
    transform: "translate(-10108.488 -15144.414)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8102",
    "data-name": "Path 8102",
    d: "M67.628,43.37,54.312,55.58a19.485,19.485,0,0,1-1.929,1.655c-.978.735-6.442,4.824-11.111,8.315a11.041,11.041,0,0,1-7.488,2.166c-.509-.3-1.038-.593-1.581-.9l-2.8-1.552-.142-.079L24.214,62.38c-.387-.192-3.341,1.481-3.731,1.336a10.706,10.706,0,0,0-3.146-.754,10.065,10.065,0,0,0-1.259-.024c-4.516.14-7.451,3.2-7.348,9.253,0,0,1.006,17.629.29,25.636-.316,3.512-2.983,13.783-2.983,13.783.24,7.022,31.9,7.151,31.855,4.255,0,0-2.053-6.331.25-17.255A108.3,108.3,0,0,0,39.918,84.47a9.065,9.065,0,0,1,3.162-5.583L59.921,64.546A18.467,18.467,0,0,0,61.555,62.9L73.43,48.587c.29-1.259-3.349-5.172-5.8-5.217",
    transform: "translate(-10115.445 -15198.069)",
    fill: "#e2e9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8103",
    "data-name": "Path 8103",
    d: "M28.633,54.392c1.6,6.637-2.158,9.1-6.8,9.037C16.66,63.364,11.752,59.612,9.807,56.1c-2.964-5.349-1.167-10.584,3.267-13.04,10.1-5.6,15,9.032,15.558,11.33",
    transform: "translate(-10111.662 -15200.642)",
    fill: "#fcbac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    d: "M11.7,47.222l.221,13.311c.011.622.6,1.212,1.655,1.578a7.262,7.262,0,0,0,5.739-.48,1.522,1.522,0,0,0,.8-1.236l-.2-13.311Z",
    transform: "translate(-10106.192 -15191.996)",
    fill: "#fcbac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8105",
    "data-name": "Path 8105",
    d: "M14.6,52.317a6.911,6.911,0,0,0,6.363.137c.6-.306.482-2.068.843-3.3.237-.8,1.009-1.128,1.191-1.547.793-1.836-1.033-6.3-4.88-6.621a12.96,12.96,0,0,0-8.658,2.411c-.279.2,2.1.227,1.939.535-1.518,2.917-.084,6.671,3.2,8.389",
    transform: "translate(-10109.895 -15202.047)",
    fill: "#343c6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M13.093,56.854l-.783-4.008A6.437,6.437,0,0,1,14.239,46.9l3.054-2.846c1.2,3.135,1.08,6.244-.337,10.5a9.412,9.412,0,0,1-2.985,4.563l-.292-.574a6.424,6.424,0,0,1-.585-1.694",
    transform: "translate(-10105.386 -15196.951)",
    fill: "#343c6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8107",
    "data-name": "Path 8107",
    d: "M13.214,42.532c4.163-2.493,9.462-.516,11.946,4.782.153.327.277.651.4.975l-3.054,2.846a6.447,6.447,0,0,0-1.931,5.947l.783,4.008a6.52,6.52,0,0,0,.585,1.694l.3.574c-.58.377-5.715,1.757-11.1-2.624-2.719-2.211-8.418-11.917,2.076-18.2",
    transform: "translate(-10113.653 -15201.187)",
    fill: "#343c6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8108",
    "data-name": "Path 8108",
    d: "M16.848,46.911c1.586.775,2.464,2.237,1.96,3.267s-2.2,1.238-3.784.464-2.464-2.237-1.96-3.267,2.2-1.238,3.784-.464",
    transform: "translate(-10104.189 -15193.047)",
    fill: "#fcbac0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLogo);
export default __webpack_public_path__ + "static/media/modal_logo.3492b3821345e7a41b95f7d738e4d808.svg";
export { ForwardRef as ReactComponent };